import BlogCard from "../components/BlogCard";import { motion } from 'framer-motion';


const blogs = [
  {
    title: 'Simplifying HTTP Requests in React with Custom Hooks 🎣',
    thumbnail:
      'https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fwrn0tvwwebkzwxno0lcs.png',
    link: 'https://dev.to/ayoashy/simplifying-http-requests-in-react-with-custom-hooks-116p',
  },
  {
    title: 'React CRUD Operations with Axios and React Query',
    thumbnail:
      'https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fexuktv41tcorm5lf92cm.png',
    link: 'https://dev.to/ayoashy/react-crud-operations-with-axios-and-react-query-19od',
  },
  {
    title: 'The call Function in Solidity',
    thumbnail:
      'https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fhx63211yde0oez25wx8o.png',
    link: 'https://dev.to/ayoashy/the-call-function-in-solidity-d0h',
  },
  {
    title: 'Code Splitting with React.lazy and Suspense',
    thumbnail:
      'https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fx77fo49077ybs222etse.png',
    link: 'https://dev.to/ayoashy/code-splitting-with-reactlazy-and-suspense-202a',
  },
];

  const sectionVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: 'beforeChildren',
      },
    },
  };

  const lineVariants = {
    hidden: { scaleX: 0 },
    visible: { scaleX: 1, transition: { duration: 0.5 } },
  };

  const headerVariants = {
    hidden: { opacity: 1, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

const BlogSection = () => (
  <motion.section
    className='bg-[#080808] text-white py-12 px-6 min-h-[100vh]'
    name='articles'
    initial='hidden'
    whileInView='visible'
    viewport={{ once: true, amount: 0.2 }}
    variants={sectionVariants}
  >
    <div className='max-w-6xl mx-auto'>
      {/* Section Header */}
      <div className='flex items-center px-[2%] mt-[100px]'>
        <motion.div
          className='w-full h-[1px] bg-[#353535]'
          variants={lineVariants}
        ></motion.div>
        <motion.p
          className='text-xl md:text-3xl text-center font-bold mx-3 text-[#4d760c] mb-4'
          variants={headerVariants}
        >
          Articles
        </motion.p>
        <motion.div
          className='w-full h-[1px] bg-[#353535]'
          variants={lineVariants}
        ></motion.div>
      </div>

      {/* Blog Cards Grid */}
      <motion.div
        className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8'
        variants={sectionVariants}
      >
        {blogs.map((blog, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.5 }}
          >
            <BlogCard blog={blog} />
          </motion.div>
        ))}
      </motion.div>
    </div>
  </motion.section>
);

export default BlogSection;
